import React from 'react'
import PropTypes from 'prop-types'
import RequestAcceptAction from 'components/Actions/RequestAccept'

const RequestAcceptPage = ({ match }) => (
  <RequestAcceptAction token={match.params.token} />
)

RequestAcceptPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default RequestAcceptPage
